<template>

	<form method="post" :action="actionDelete">
	    <input type="hidden" name="_token" :value="csrfToken">
	    <input type="hidden" name="_method" value="DELETE">
		<div class="card">
			<div class="card-footer d-flex align-items-center">
				<div class="m-0">
					<button type="button" class="btn btn-primary" v-on:click="getPostBack();">
						<svg xmlns="http://www.w3.org/2000/svg" class="icon" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round"><path stroke="none" d="M0 0h24v24H0z" fill="none"/><line x1="5" y1="12" x2="19" y2="12" /><line x1="5" y1="12" x2="9" y2="16" /><line x1="5" y1="12" x2="9" y2="8" /></svg>
						Back
					</button>
					<button type="button" class="btn btn-success" v-on:click="getPostEdit();">
						<svg xmlns="http://www.w3.org/2000/svg" class="icon" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round"><path stroke="none" d="M0 0h24v24H0z" fill="none"/><path d="M9 7h-3a2 2 0 0 0 -2 2v9a2 2 0 0 0 2 2h9a2 2 0 0 0 2 -2v-3" /><path d="M9 15h3l8.5 -8.5a1.5 1.5 0 0 0 -3 -3l-8.5 8.5v3" /><line x1="16" y1="5" x2="19" y2="8" /></svg>	
						Edit
					</button>
				</div>
				<div class="m-0 ms-auto">
					<button v-if="data.isAuth && data.isUpload && data.isAuthority" v-on:click="getPostVerify();" type="button" data-id="2" data-label="Verified" id="btnAction" class="btn btn-pink">
						<svg xmlns="http://www.w3.org/2000/svg" class="icon" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round"><path stroke="none" d="M0 0h24v24H0z" fill="none"/><circle cx="12" cy="12" r="9" /><path d="M9 12l2 2l4 -4" /></svg>
						Verify
					</button>
					<button v-if="data.isAuth && data.isVerify && data.isAuthority" v-on:click="getPostPublish();" type="button" data-id="3" data-label="Published" id="btnAction" class="btn btn-teal">
						<svg xmlns="http://www.w3.org/2000/svg" class="icon" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round"><path stroke="none" d="M0 0h24v24H0z" fill="none"/><path d="M15 10l-4 4l6 6l4 -16l-18 7l4 2l2 6l3 -4" /></svg>
						Publish
					</button>
					<button type="button" v-on:click="getPostDelete();" class="btn btn-danger">
						<svg xmlns="http://www.w3.org/2000/svg" class="icon" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round"><path stroke="none" d="M0 0h24v24H0z" fill="none"/><line x1="4" y1="7" x2="20" y2="7" /><line x1="10" y1="11" x2="10" y2="17" /><line x1="14" y1="11" x2="14" y2="17" /><path d="M5 7l1 12a2 2 0 0 0 2 2h8a2 2 0 0 0 2 -2l1 -12" /><path d="M9 7v-3a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v3" /></svg>
						Delete
					</button>
				</div>
			</div>
		</div>
	</form>

</template>




<script>
	import Swal from 'sweetalert2'

	export default {
		props: ['data'], 
		data() {
			return {
				csrfToken: "",
				actionDelete: '/module/posts/' + this.data.hashslug + '/destroy',
				verified: 2,
				published: 3,
			};
		},
		mounted() {
			this.csrfToken = document.head.querySelector('meta[name="csrf-token"]').content;
		},
		methods: {
			getPostBack() {
				window.location.href = '/module/posts';
			},
			getPostEdit() {
				window.location.href = '/module/posts/' + this.data.hashslug + '/edit';				
			},
			getPostUpdate(status) {
    			const form = new FormData();
    			form.append('hashslug', this.data.hashslug);
    			form.append('status', status);
    			axios.post('/api/ajax/mod/posts/update_status', form)
	    			.then(res => {
	    				window.location.href = '/module/posts/' + this.data.hashslug + '/view';
	    		    })
	    		    .catch(err => {  
	    		    	console.log(err);                  
	    		    }); 
			},
			getPostVerify() {
				this.getPostUpdate(this.verified);
			},
			getPostPublish() {
				this.getPostUpdate(this.published);
			},
			getPostDelete() {
				Swal.fire({
					title: 'Are you sure?',
					text: "You won't be able to revert this!",
					icon: 'warning',
					showCancelButton: true,
					confirmButtonColor: '#3085d6',
					cancelButtonColor: '#d33',
					confirmButtonText: 'Yes'
				}).then((result) => {
					if (result.isConfirmed) {
		    			const form = new FormData();
		    			form.append('hashslug', this.data.hashslug);
		    			axios.post('/api/ajax/mod/posts/delete', form)
			    			.then(res => {
			    				window.location.href = '/module/posts';
			    		    })
			    		    .catch(err => {  
			    		    	console.log(err);                  
			    		    }); 
						
					}
				})

			},
		},
	}
</script>       